import * as React from 'react';
import Th from "./th";
import ParagraphSup from "../text/paragraph_sup";

interface IProps
    extends React.DetailedHTMLProps<React.ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement> {
}

const ThWithText: React.FC<IProps> = (props) => {

    const { children, ref, ...ThProps } = props;

    return(<Th {...ThProps} ><ParagraphSup bold={true}>{children}</ParagraphSup></Th>);

};

export default ThWithText;





// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/th_with_text.tsx